/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { ListItem, Button, Collapse } from '@mui/material';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <RouterLink {...props} />
  </div>
));

const renderLabel = (Label) => {
  if (!Label) return null;

  return (
    <span className="menu-item-label">
      {typeof Label === 'string' ? (
        <span className="badge badge-warning">{Label}</span>
      ) : (
        <Label />
      )}
    </span>
  );
};

const SidebarMenuListItem = (props) => {
  const {
    title,
    href,
    depth,
    children,
    icon: Icon,
    className,
    open: openProp,
    label: Label,
    disabled,
    ...rest
  } = props;

  const [open, setOpen] = React.useState(openProp);

  const handleToggle = () => {
    setOpen((openData) => !openData);
  };

  let paddingLeft = 14;

  if (depth > 0) {
    paddingLeft = 32 + 20 * depth;
  }

  const style = {
    paddingLeft
  };

  if (children) {
    return (
      <ListItem
        {...rest}
        className={clsx('app-sidebar-item', className)}
        disableGutters
      >
        <Button
          color="primary"
          className={clsx('app-sidebar-button', { active: open })}
          onClick={handleToggle}
          style={style}
        >
          {Icon && <Icon className="app-sidebar-icon" />}
          <span>{title}</span>
          {open ? (
            <ExpandLessIcon className="sidebar-expand-icon" color="inherit" />
          ) : (
            <ExpandLessIcon
              className="sidebar-expand-icon sidebar-expand-icon-rotate"
              color="inherit"
            />
          )}
        </Button>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    );
  }

  if (disabled) {
    return (
      <ListItem
        {...rest}
        className={clsx('app-sidebar-item', className)}
        disableGutters
      >
        <Button
          color="primary"
          disableRipple
          disabled
          variant="text"
          className={clsx('app-sidebar-button-wrapper', 'disabled-item', `depth-${depth}`)}
          style={style}
        >
          {Icon && <Icon className="app-sidebar-icon" />}
          {title}
          {renderLabel(Label)}
        </Button>
      </ListItem>
    );
  }

  return (
    <ListItem
      {...rest}
      className={clsx('app-sidebar-item', className)}
      disableGutters
    >
      <Button
        activeClassName="active-item"
        color="primary"
        disableRipple
        variant="text"
        className={clsx('app-sidebar-button-wrapper', `depth-${depth}`)}
        component={CustomRouterLink}
        exact
        style={style}
        to={href}
      >
        {Icon && <Icon className="app-sidebar-icon" />}
        {title}
        {renderLabel(Label)}
      </Button>
    </ListItem>
  );
};

SidebarMenuListItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.any,
  label: PropTypes.any,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired
};

SidebarMenuListItem.defaultProps = {
  depth: 0,
  disabled: false,
  open: false
};

export default SidebarMenuListItem;
